import axios from 'axios'

export default {
  namespaced: true,
  state: {
    cluster: {
      name: '',
      requiredCases: 0
    },
    clusters: []
  },
  mutations: {
    CLUSTER (state, cluster) {
      state.cluster = cluster
    },
    CLUSTERS (state, clusters) {
      state.clusters = clusters
    }
  },
  getters: {
    getCluster (state) {
      return state.cluster
    },
    getClusters (state) {
      return state.clusters
    }
  },
  actions: {
    resetCluster (context) {
      context.commit('CLUSTER', {
        name: '',
        requiredCases: 0
      })
    },
    setCluster (context, cluster) {
      context.commit('CLUSTER', cluster)
    },
    clearClusters (context) {
      context.commit('CLUSTERS', [])
    },
    saveCluster (context) {
      let formData = new FormData()
      let cluster = context.state.cluster

      formData.append('cluster', JSON.stringify(cluster))
      formData.append(
        'validationCycle',
        JSON.stringify(
          context.rootGetters['petra/validationCycles/getValidationCycle']
        )
      )
      formData.append(
        'responsibleParty',
        JSON.stringify(context.rootGetters['petra/rps/getRP'])
      )
      return axios.post('/api/cluster/save', formData).then(res => {
        context.commit('CLUSTER', {
          name: '',
          requiredCases: 0
        })
        return res.data
      })
    },
    loadClusters (context, { filter }) {
      return axios
        .get('/api/cluster/list', {
          params: {
            filter: JSON.stringify(filter)
          }
        })
        .then(res => {
          context.commit('CLUSTERS', res.data.clusters)
        })
    }
  }
}
